import React from 'react';
import { SelectInput } from '../../reusable-components/SelectInput';

const CURRENT_YEAR = new Date().getFullYear();
const START_YEAR = 1990;

const YEAR_OPTIONS = Array.from(
  { length: CURRENT_YEAR - START_YEAR + 1 },
  (_, i) => {
    const year = CURRENT_YEAR - i;
    return { value: String(year), option: String(year) };
  },
);

const MONTH_OPTIONS = Array.from({ length: 12 }, (_, i) => {
  const month = String(i + 1).padStart(2, '0');
  return { value: month, option: month };
});

interface InvoiceDownloaderDownloadFormProps {
  invoices: number;
  onInvoicesChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  fromYear: string;
  onFromYearChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  fromMonth: string;
  onFromMonthChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const InvoiceDownloaderDownloadForm: React.FC<
  InvoiceDownloaderDownloadFormProps
> = ({
  invoices,
  onInvoicesChange,
  fromYear,
  onFromYearChange,
  fromMonth,
  onFromMonthChange,
}) => {
  return (
    <>
      <div className="flex flex-wrap gap-4 items-end">
        <SelectInput
          label="From Year:"
          value={fromYear}
          onChange={onFromYearChange}
          valuesAndOptions={YEAR_OPTIONS}
          width="w-1/3"
        />
        <SelectInput
          label="From Month:"
          value={fromMonth}
          onChange={onFromMonthChange}
          valuesAndOptions={MONTH_OPTIONS}
          width="w-1/3"
        />
        <SelectInput
          label="Number of Invoices:"
          value={invoices}
          onChange={onInvoicesChange}
          valuesAndOptions={Array.from({ length: 30 }, (_, i) => ({
            value: i + 1,
            option: `${i + 1} invoice${i === 0 ? '' : 's'}`,
          }))}
          width="w-1/3"
        />
      </div>
      <div className="flex items-center space-x-2 my-2">
        <svg
          className="w-5 h-5 text-warning flex-shrink-0"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span className="text-warning text-sm font-medium">
          Downloading 3 or more invoices can take more than 5 minutes.
        </span>
      </div>
    </>
  );
};
